export default {
  cancelOrderMap: {
    0: "Ek wil dit nie hê nie.",
    1: "Het die produk misplaas",
    2: "Duplikaat bestelling",
    3: "Ontvangs het misluk",
    4: "Ander redes",
  },
  "获取验证码":'Verkieer code',
  "验证码":'Verkieer code',
  "请输入验证码":'Voer asseblief die verkieer code in',
  "发送": 'Verstuur',
  "已发送，请注意查收":"Hierbys verstuur, kies asseblief u naam en adres",
  "电商批发商场": "Elektroniese groothandelsmark",
  "当前余额": "huidige balaans",
  "备注":  "Opmerkings",
  "请输入完整的支付密码!": "Voer asseblief die volledige betaal wagwoord in!",
  "暂无店铺": "Geen winkel nie",
  "用户未发表评论": "User has not commented",
  "订单": "Orde",
  "下单成功，等待付款": "Bestelling suksesvol geplaas, wag vir betaling",
  "下单成功，付款成功": "Bestelling suksesvol geplaas, betaling geslaag",
  "已发货，正在运输中": "Gestuur, in vervoer",
  "订单已取消，原因:手动发起取消订单": "Die bestelling is gekanselleer. Rede: Kanselleer die bestelling met die hand.",
  "订单已取消，原因:超时自动取消订单": "Bestelling is gekanselleer. Rede: Bestelling sal outomaties gekanselleer word met uitteltyd.",
  "商家已确认，已进入备货状态": "Die handelaar is bevestig en het die voorraadstaat betree.",
  "系统发货成功": "Stelselaflewering het geslaag",
  "订单已签收": "Bestelling ontvang",
  "发起退款申请": "Begin 'n terugbetalingversoek",
  "长时间未付款，系统自动取消订单": "Indien betaling vir 'n lang tyd nie gemaak word nie, sal die stelsel outomaties die bestelling kanselleer.", 
  "退款成功": "Terugbetaling het geslaag",
  "退款失败": "Terugbetaling het misluk",
  "订单退款成功": "Terugbetaling van bestelling het geslaag",
  "订单退款失败": "Terugbetaling van bestelling het misluk",
  "系统默认好评": "Die stelsel is verstek na gunstige resensies",
  "请输入关键字搜索": "Voer asseblief sleutelwoord in om te soek",
  "猜你喜欢": "Raai jy hou daarvan",
  "订单已完成": "Die bestelling is voltooi",
  "热销推荐": "Warm verkoopsaanbeveling",
  "头像选择": "Avatar seleksie",
  "修改头像": "Verander jou avatar",
  subOrder: "Dien bestelling in",
  "mailboxCheck": "Vul asseblief die korrekte e-posadres in",
  "switchLang": "Skakel asseblief oor na 'n ander taal om te sien",
  "myCart": "My inkopiemandjie",
  "notQua": "Die kwalifikasievoorwaardes word nie nagekom nie.",
  "noSmaller": "Die toegediende hoeveelheid kan nie minder wees as",
  "nomax": "Die maksimum aansoekbedrag kan nie oorskry nie",
  "evaluationUploading": "Jy het nog foto's wat oplaai. Probeer asseblief weer later",
  "evaluateInput": "Hersien met prente",
  "moneyOrderStatus": "Bestellingstatus",
  "coinBlock": "Valuta-ooreenkoms",
  "dealing": "In proses",
  "dealSuccess": "Suksesvol",
  "dealFail": "Misluk",
  "payCertificate": "Betalingsertifikaat",
  "handleFee": "Diensfooi",
  "highOpinion": "Goeie resensies",
  "mediumOpinion": "Medium resensie",
  "lowOpinion": "Slegte resensies",
  "hasImage": "Met prentjies",
  "rechargeMethod": "Herlaai-modus",
  "scanAndDown": "Skandeer QR-kode Laai APP af",
  "receivedAddress": "Kwitansie adres",
  "ActualLedger": "Werklike kwitansie",
  "view": "Beskou",
  "withdrawNum": "Kontant onttrekking hoeveelheid",
  "rechargeNum": "Herlaai hoeveelheid",
  "date": "Datum",
  "walletHistory": "Beursie geskiedenis",
  "accountBalance": "Rekening balans",
  "accountReview": "Rekeningoorsig",
  "rated": "Hersien",
  "receiver": "Ontvanger",
  "orderStatus": "Status",
  "orderTime": "Tyd",
  "tax": "Belasting",
  "discount": "Afslag",
  "productInfo": "Produk inligting",
  "paramError": "Parameterfout",
  "orderInfo": "Bestel inligting",
  "rebuy": "Nog 'n bestelling",
  "pleaseCorrectAddress": "Voer asseblief die korrekte kontantonttrekkingadres in",
  "pleaseInputCorrectNumber": "Voer asseblief 'n getal groter as 0 in",
  "vcodePass": "Verifikasie geslaag!",
  "vcodeFail": "Stawing het misluk, probeer asseblief weer",
  "uploading": "Laai tans op...",
  "uploadSuccess": "Opgelaai geslaag",
  "uploadError": "Oplaai het misluk. Probeer asseblief weer",
  "registerSuccess": "Registrasie geslaag",
  "pleaseSetMobileNumber": "Stel asseblief die telefoonnommer",
  "unSelectedProduct": "Jy het nie 'n produk gekies nie",
  "loginSuccess": "Aanmelding geslaag",
  "pleaseSetAreaCode": "Voer landnaam en areakode in om te soek",
  "login": "Teken aan",
  "register": "Registrasie",
  "logout": "Verlaat",
  "noData": "Geen data gevind nie",
  "search": "Soek",
  "historySearch": "Historiese soektog",
  "empty": "Leeg",
  "home": "Tuisblad",
  "favorableRate": "Koers van goeie resensies",
  "classification": "Kategorie",
  "searchTips": "Bronsoektog/produk/verskaffer/bestelling",
  "dailyNewArrival": "Daaglikse nuwe produkte gelys",
  "more": "Meer",
  "recommend": "Aanbeveling",
  "recommendedProducts": "Aanbevole produkte",
  "recommendedStore": "Aanbevole winkels",
  "buyNow": "Koop nou",
  "addCart": "Voeg by inkopiemandjie",
  "complex": "Geïntegreerde",
  "price": "Prys",
  "retailPrice": "Kleinhandel prys",
  "originPrice": "Oorspronklike prys",
  "service": "Kliëntediens",
  "collect": "Gunstelinge",
  "sold": "Verkoopsvolume",
  "pageviews": "Hoeveelheid blaai",
  "quantity": "Hoeveelheid",
  "freight": "Vrag",
  "shipping": "Gestuur",
  "ship": "Boot",
  "buyTips": "Stuur binne 24 uur na die bestelling geplaas. Die volgende bestellings is onder logistieke beheer en kan laat versend word. Gee asseblief aandag aan logistieke inligting of kontak kliëntediens.",
  "totalPrice": "Totale prys",
  "addCartMessage": "Suksesvol by inkopiemandjie gevoeg",
  "addCartMessageFaild": "Die produk bestaan reeds in die inkopiemandjie.",
  "myAccount": "My qccount",
  "buyHistory": "Koop rekords",
  "wishlist": "Gunsteling produkte",
  "trackOrder": "Orde",
  "account": "Rekening:",
  "sellerZone": "Handelaar gebied",
  "beSeller": "Word 'n handelaar",
  "sellerPanelLogin": "Handelaar aanmeld",
  "footTip": "© Kopiereg {name} Bpk 2024",
  "footTips": "{name} Beperk is gemagtig en gereguleer deur die Finansiële Gedragsowerheid as 'n kredietmakelaar (713206) en handel uitsluitlik met die lener Home Retail Group CardServices Limited as {name} Financial Services. {name} Financial Services word deur die Finansiële Gedragsowerheid gemagtig en gereguleer om krediet te verskaf (716148). Home Retail GroupCard Services Limited is geregistreer in die Verenigde Koninkryk (04007072) by Avebury, 489-499 Avebury Boulevard, Milton Keynes, Verenigde Koninkryk. MK9 2NW.",
  "item": "Artikel",
  "checkout": "Plaas 'n bestelling",
  "productDescription": "Produk Beskrywing",
  "userEvaluation": "Gebruiker resensies",
  "AllProducts": "Alle produkte",
  "followers": "Volg",
  "sales": "Verkoopsvolume",
  "visitStore": "Besoek die winkel",
  "authentic": "100% eg",
  "dayReturns7": "7 dae terugkeer",
  "shippingDiscounts": "Vrag afslag",
  "safePayment": "Veilige betaling",
  "followed": "Gevolg",
  "dashboard": "Instrumentepaneel",
  "myOrder": "My bestelling",
  "setUp": "Stel op",
  "successTips": "Suksesvol",
  "copySuccess": "Replikasie het geslaag",
  "balance": "Saldo (USDT)",
  "sort": "Tik",
  "commodity": "Produk",
  "browse": "Verkoopsvolume",
  "recharge": "Herlaai",
  "commodityCollection": "Produkversameling",
  "withdraw": "Kontant onttrekking",
  "defaultAddress": "Verstek adres",
  "addNewAddress": "Voeg nuwe adres by",
  "withdrawRecord": "Kontantonttrekkingsrekord",
  "serialNumber": "Bestelling nommer.",
  "time": "Tyd",
  "amount": "Bedrag",
  "processing": "In proses",
  "fail": "Misluk",
  "blockchainNetwork": "Blockchain netwerk",
  "records": "Rekord",
  "withdrawAddress": "Kontant onttrekking adres",
  "withdrawInputTips": "Voer asseblief die onttrekkingadres in",
  "copy": "Replikasie",
  "enterTips": "Kom asseblief in",
  "actualAccount": "Werklike rekening",
  "handlingFee": "Diensfooi",
  "confirm": "Bevestig ontvangs",
  "previous": "Vorige stap",
  "pleaseEnterAddress": "Voer asseblief die adres in",
  "pleaseEnterQuantity": "Voer asseblief hoeveelheid in",
  "withdrawSuccess": "Bestellings suksesvol ingedien",
  "saveQr": "Stoor QR-kode",
  "pleaseEnterAmount": "Voer asseblief die herlaaibedrag in",
  "expectedArrival": "Verwagte aankoms",
  "currentRate": "Huidige wisselkoers",
  "uploadTips": "Bewys van betaling (Laai skermskoot van betalingbesonderhede op)",
  "clickUpload": "Klik om op te laai",
  "uploadPhoto": "Laai asseblief foto's op",
  "rechargeSuccessful": "Herlaai het geslaag",
  "rechargeTips": "\"Herlaai-aanvraag: \"\"Vul asseblief die werklike oordragbedrag eerlik in. Andersins kan die stelsel nie die goedkeuring slaag nie en die herlaaivordering beïnvloed.\"",
  "rechargeRecord": "Herlaai rekord",
  "all": "Almal",
  "pending": "Om betaal te word",
  "cancelled": "Gekanselleer",
  "delivered": "Om gestuur te word",
  "confirmed": "Bevestig",
  "receipt": "Om ontvang te word",
  "harvested": "Ontvang",
  "comment": "Om hersien te word",
  "refund": "Terugbetaling/na-verkope",
  "cancelOrder": "Kanselleer bestelling",
  "cancelReason": "Rede vir kansellasie",
  "cancelOrderTitle": "Kies asseblief 'n rede vir bestellingkansellasie",
  "returnOrderTitle": "Kies asseblief die rede vir die terugkeer",
  "refundInstructions": "Terugbetalingsinstruksies",
  "returnDetailTips": "Gee asseblief 'n resensie oor die produk",
  "cancel": "Kanselleer bestelling",
  "cancelOrder1": "Produk nie ontvang nie",
  "cancelOrder2": "Hou nie daarvan nie, wil dit nie hê nie",
  "cancelOrder3": "Die verkoper het die verkeerde goedere gestuur",
  "cancelOrder4": "Valse handelsmerk",
  "cancelOrder5": "Minder versending, gemis versending",
  "cancelOrder6": "Produk ontvang is beskadig",
  "cancelOrder7": "Daar is 'n kwaliteit probleem",
  "cancelOrder8": "Onderhandel terugbetaling met die handelaar",
  "cancelOrder9": "Ander redes",
  "cancelOrderSuccess": "Bestelling is suksesvol gekanselleer",
  "returnOrderSuccess": "Dien suksesvol in",
  "orderName": "Naam",
  "orderEmail": "E-pos",
  "orderAddress": "Adres",
  "orderNation": "Land",
  "orderState": "Status",
  "orderCity": "Stad",
  "orderPostCode": "Poskode",
  "orderAmount": "Hoeveelheid",
  "orderPrefix": "Totale bestelling",
  "orderFee": "Belasting",
  "orderSpecification": "Spesifikasie",
  "orderCommodity": "Produk",
  "orderQuantity": "Hoeveelheid",
  "orderUnitprice": "Eenheidsprys",
  "orderFreight": "Vrag",
  "orderTax": "Belasting",
  "orderTotal": "Totaal",
  "PaymentOrder": "Betalingsopdrag",
  "Evaluate": "Resensie",
  "CancelOrder": "Kanselleer bestelling",
  "RemindShip": "Herinnering vir versending",
  "Refund": "Terugbetaling",
  "Submitareview": "Dien resensies in",
  "Information": "Inligting",
  "wrongPassword": "Wagwoordfout meer as 3 keer. Probeer asseblief môre weer.",
  "Operate": "Operasie",
  "Item": "Item(e)",
  "From": "Van",
  "hint": "Wenke",
  "CheckDetails": "Sien besonderhede",
  "Payment": "Betaling",
  "Cancel": "Kanselleer",
  "refundSuccessfully": "Terugbetaling het geslaag",
  "pendingPayment": "Om betaal te word",
  "pay": "Betaling",
  "LoginPassword": "Aanteken wagwoord",
  "sure": "Natuurlik",
  "shippingAddress": "Ontvangs adres",
  "pleaseAddShippingAddress": "Voeg asseblief 'n afleweringsadres by",
  "transactionPassword": "Transaksie wagwoord",
  "markDefaultAddress": "Merk as verstekversendingsadres",
  "edit": "Geredigeer deur",
  "delete": "Vee uit",
  "Opt": "Kies",
  "piece": "Stk",
  "orderDetails": "Bestel besonderhede",
  "shopCollection": "Voeg die winkel by gunsteling",
  "addAddress": "Voeg nuwe adres by",
  "signUp": "Registrasie",
  "loginTips": "Reeds 'n rekening?",
  "loginIn": "Teken aan",
  "mobile": "Telefoon nommer",
  '购物车还没有商品': "Die inkopiemandjie het nog nie produkte nie",
  '去购物': "Gaan inkopies doen",
  "modifyAddress": "Wysig adres",
  "desc": "Stel as verstekadres",
  "keep": "Handhaaf",
  "onlineService": "Aanlyn dienste",
  "send": "Stuur",
  "EsShop": "Aanlyn winkel",
  "desc3": "Voer transaksiewagwoord in",
  "desc4": "Voer jou transaksiewagwoord in",
  "desc6": "Voer weer jou transaksiewagwoord in",
  "setUpPayPaw": "Stel transaksiewagwoord in",
  "setSuccess": "Opstelling het geslaag",
  "confirmPayPaw": "Bevestig transaksiewagwoord",
  "paymentSuccessful": "Betaling het geslaag",
  "paymentPending": "Betaling hangende",
  "paymentPendingDesc": "Jou betaling word verwerk. Kontroleer asseblief jou bestellingstatus later",
  "desc5": "Verkeerde afleweringsadres? Kontak",
  "customeService": "Aanlyn kliëntediens",
  "BackHome": "Terug na tuisblad",
  "Checkorder": "Besigtig bestelling",
  "ForgotPassword": "Die wagwoord vergeet?",
  "signIn": "Teken aan",
  "noAccount": "Geen rekeningnommer nie?",
  "pleaseEnterAccount": "Voer asseblief rekeningnommer in",
  "pleaseEnterPassword": "Voer asseblief wagwoord in",
  "password": "Wagwoord",
  "mobilePhone": "Telefoon nommer",
  "pleaseEnterPhoneNumer": "Stel asseblief die telefoonnommer",
  "setPassword": "Stel wagwoord in",
  "noDataFound": "Geen data gevind nie",
  "searchCountry": "Voer landnaam en areakode in om te soek",
  "pleaseEnterEmail": "Stel asseblief die posbus",
  "invitationCode": "Uitnodigingskode",
  "plaeseEnterInvitaionCode": "Stel asseblief die uitnodigingskode",
  "pleaseSetLoginPassword": "Stel asseblief die aanmeldwagwoord in",
  "selectDeliveryAddress": "Kies afleweringsadres",
  "totalOf": "Totaal",
  "items": "Item",
  "orderSummary": "Bestelling opsomming",
  "paymentMethod": "Betalings metode",
  "Balance": "Balans",
  "payPal": "PayPal",
  "notOpen": "Hierdie betaalmetode is nog nie oop vir jou streek nie",
  "mastercard": "MasterCard",
  "additional": "Ekstra",
  "handlingfee": "Diensfooi word vereis",
  "goodsNumber": "Hoeveelheid produkte",
  "deliveryFee": "Vrag",
  "totalNum": "Totaal",
  "new": "Nuut",
  "oldPassword": "Ou wagwoord",
  "pleaseEnterOldPassword": "Voer asseblief die ou wagwoord in",
  "newPassword": "Nuwe Wagwoord",
  "plaseeEnterNewPassword": "Voer asseblief die nuwe wagwoord in",
  "confirmPassword": "Bevestig Wagwoord",
  "plaseeENterConfirmPassword": "Voer asseblief die bevestigingswagwoord in",
  "twoPawword": "Twee wagwoorde is nie dieselfde nie",
  "rechargeAddress": "Herlaai adres",
  "plaseEnterRechargeAddress": "Voer asseblief die herlaaiadres in",
  "userCenter": "Persoonlike sentrum",
  "merchantSettled": "Handelaarinskrywing",
  "upNew": "Nuwe produk gelys",
  "balanceNot": "Die balans is nie genoeg nie. Herlaai asseblief.",
  "NoProductSelected": "Produk nog nie gekies nie",
  "ShippingAddressNotSet": "Versendingsadres nie gestel nie",
  "consigneeName": "Naam van ontvanger",
  "email": "E-pos:",
  "areaCode": "Internasionale area kode",
  "phoneNumber": "Telefoon nommer",
  "nation": "Land",
  "state": "Provinsie/Staat/Staat",
  "city": "Stad",
  "postCode": "Poskode",
  "address": "Gedetailleerde adres",
  "addAddressOrModifyAddress": "Voeg nuwe adres by/Verander adres",
  "setAsTheDefaultAddress": "Stel as verstekadres",
  "proceed": "Aanhou",
  "btnSure": "Bevestig",
  "pleaseInput": "Kom asseblief in",
  "allProduct": "Alle produkte",
  "myCommodityCollection": "Gunsteling produkte",
  "myFollowedShops": "Volg die winkel",
  "mySold": "Verkoop",
  "myPageviews": "Hoeveelheid blaai",
  "myPraiseRate": "Koers van goeie resensies",
  "myUnfollow": "Ontvolg",
  "inputNum": "Getalle",
  "inpuEmailErro": "Voer asseblief die korrekte e-posadres in",
  "goodsShip": "Versending",
  "goodsShipTips": "Die produkte sal binne 24 uur na die bestelling gestuur word. Indien logistieke beheer vir die volgende bestelling bestaan, kan die bestelling vertraag word. Let asseblief op die logistieke inligting van die bestelling of kontak die kliëntediens.",
  "goodsFreight": "Vrag",
  "goodsFreeShipping": "Verniet",
  "goodsFreightTips1": "1. Oorgrens produkvragsamestelling: vrag=versendingsfooi+ langafstandvrag+ afleweringsfooi",
  "goodsFreightTips2": "2. Indien die posvoorwaardes nie nagekom word nie, sal die vrag volgens die werklike voorwaardes gehef word.",
  "goodsFreightTips3": "3. Die reg op finale uitleg behoort aan die platform.",
  "pleaseValidPostCode": "Voer asseblief meer as 4 syfers in",
  "pleaseValidEmail": "Voer asseblief die korrekte e-posadres in",
  "pleaseValidPhone": "Voer asseblief die korrekte telefoonnommer in",
  "productAvailable": "Hierdie produk is afgeneem",
  "validatorMaxNumber": "Bedrag oorskry die limiet",
  "validatorRequire": "Vereiste items kan nie nul wees nie",
  "validatorPhone": "Voer asseblief die korrekte telefoonnommer in",
  "validatorEmail": "Voer asseblief die korrekte e-posformaat in",
  "validatorPassword": "Die wagwoord bestaan uit 6-12 syfers of letters(bevat spesiale karakters)",
  "validatorSixNumber": "Voer asseblief 6 suiwer syfers in",
  "validatorFourMoreNumber": "Voer asseblief 'n kombinasie van 4-32 syfers of letters in",
  "validatorIpRule": "Verkeerde IP-formaat",
  "validatorChineseAndEnglish": "Slegs Chinees en Engels, voer reeks in: 8-64 karakters",
  "collectionSuccess": "Voeg suksesvol by gunsteling",
  "followedSuccess": "Volg geslaag",
  "cancelSuccess": "Gekanselleer geslaag",
  "evaluateOrder": "Hersien met prente",
  "evaluateOrderPlaceholder": "Hersien asseblief die produkte",
  "operationSuccess": "Operasie het geslaag",
  "confirmReceiveGoods": "Bevestig ontvangs van die produk of nie",
  "evaluateOrderSuccess": "Hersiening het geslaag",
  "yesterday": "Gister",
  "notLogin": "Jy het nog nie aangemeld nie.",
  "delAllHistoryRecord": "Is jy seker jy wil al die geskiedenisrekord uitvee?",
  "or": "Of",
  "tipsRemindsText": "Die handelaar sal 'n aanmaning ontvang nadat die versending herinner is",
  "tipsRemindsCount": "Dit kan net een keer herinner word.",
  "tipsRemindsMerchant": "Herinner handelaars",
  "tipsRemindsSuccess": "Herinnering het geslaag",
  "noCartTips": "Jou inkopiesak is leeg. Begin inkopies doen.",
  "defaultRate": "Die stelsel is verstek na gunstige resensies",
  "prevPage": "Vorige bladsy",
  "nextPage": "Volgende bladsy",
  "returnApply": "Terugbetaling versoek",
  "returnReason": "Rede vir terugbetaling",
  "returnAmount": "Retourbedrag",
  "returnRemark": "Gee instruksies terug",
  order: {
    cancel: "Kanselleer bestelling",
    confirm: "Bevestig ontvangs",
    payment: "Betaal nou",
    remind: "Herinnering vir versending",
    return: "Versoek om produkterugbetaling",
    evaluate: "Hersien nou",
    logistics: "Kyk na logistiek",
    noRefund: "Onterugbetaal",
    refunding: "Terugbetaling aan die gang",
    refundSuccess: "Terugbetaling het geslaag",
    refundFail: "Terugbetaling het misluk",
  },
  "remindTitle": "Herinnering vir versending",
  "remindContent": "Nadat die versending herinner is, sal die handelaar die aanmaning ontvang. Dit kan net een keer herinner word.",
  "remindSuccess": "Herinnering het geslaag",
  "remindRepeat": "Hierdie bevel is herinner.",
  "noComments": "Geen resensie tans nie",
  "storeSeach": "Soek vir produk in hierdie winkel",
  "storeSeachTips1": "Vir jou gevind",
  "storeSeachTips2": "Verwante winkels gevind",
  "storeSeachTips3": "Tuis",
  "creditTit": "Kredietdienste",
  "getCoupons": "Kry meer koepons",
  "yourEmail": "Jou eposadres",
  "subscription": "Subskripsies",
  "paymethods": "Betalings metode",
  "footdec": "{name} globale werfgebruikers kom van {num} lande regoor die wêreld en gebruik {coin} vir nedersetting. {coin} is 'n grenslose transaksie wat onmiddellike, laekostetransaksies regoor die wêreld moontlik maak sonder om te wag en internasionale fooie.",
  "custService": "Kliëntediens",
  "helpLine": "Aanlyn kliëntediens",
  "contactUs": "Kontak Ons",
  "partner": "Koöperatiewe verskaffers",
  "buyRules": "Koper reëls",
  "sellerRules": "Verkoper se beleid",
  "returnsAndEx": "Opgawes en ruil",
  "servicePolicy": "Diensbeleid",
  "returnPolicy": "Retourbeleid",
  "user_Center": "Gebruikersentrum",
  "userReg": "Gebruikersregistrasie",
  "orderTrack": "Bestelling navraag",
  "purchageHistory": "Aankoop geskiedenis",
  "myPurse": "My beursie",
  "aboutUs": "Oor ons",
  "Recruitment": "Wag vir talentvolle persone",
  "news": "Nuus inligting",
  "stateMent": "Moderne slawerny verklaring",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "okx",
  "metaMask": "Metamasker",
  "homeBannertips1": "Word 'n handelaar",
  "homeBannertips2": "Totale kommissie",
  "homeBannertips3": "Maks.",
  "homeBannerbtn": "Sluit nou aan",
  "homeDownloadtips1": "Oorgrens e-handel groothandel winkelsentrum",
  "homeDownloadtips2": "Handelsmerk spesiale aanbod",
  "homeDownloadtips3": "Ononderbroke afslag",
  "homeDownloadtips4": "Android aflaai",
  "homeDownloadtips5": "Apple aflaai",
  "homeDownloadtips6": "Skandeer QR-kode om APP af te laai",
  "homeIconTips1": "100% eg",
  "homeIconTips2": "7 dae terugkeer",
  "homeIconTips3": "Vrag afslag",
  "homeIconTips4": "Veilige betaling",
  "headerSearchTips": "Voer asseblief sleutelwoord in om te soek",
  "collAccount": "Leenwyse",
  "mine": "Myne.",
  "creditText1": "Aanvangslenings los die moeilikheid om geld te leen op",
  "creditText2": "Verskaf aanvangslenings- en kapitaalomsetdienste",
  "creditWorry": "Bekommernisvrye lening",
  "creditQuota": "Buigsame limiet",
  "creditQuotaINFO": "100,000 tot 30,000,000 met buigsame limiet en geen beperkings, met 'n maksimum leningstermyn van een jaar.",
  "quickLoan": "Vinnige lening",
  "creditReview": "Slaag die oudit op die vroegste binne een uur, as die hersiening geslaag word, sal die lening dadelik vrygestel word.",
  "safe": "Veilig en sonder kommer",
  "safeInfo": "Geen verband, geen deposito, geen terugbel nie, want dit is eintlik 'n private aangeleentheid.",
  "about": "Oor ons",
  "aboutText1": "\"Ons is daartoe verbind om finansiële dienste te leen, gebaseer op die \"\"kliënt eerste\"\" besigheidsfilosofie, en het die missie om die probleem van kliëntekapitaalomset op te los. Sedert sy stigting het die maatskappy talle kliënte gehelp om die probleem van kapitaalomset op te los.\"",
  "aboutText2": "Limiet: 100 000-30 000 000, buigsame terugbetalingsmetode met lae rente, geen vooraffooi, aanlynlening, geen telefoonoproep vir verifikasie, vertroulike inligting en uitleen op dieselfde dag.",
  "contactUs1": "As jy nie geld by jou vlakmaats wil leen nie, kontak ons asseblief.",
  "committed": "Toegewyd tot entrepreneursleningsdienste",
  "financial": "Gee aandag aan jou finansiële bekommernisse",
  "partnersTit": "Vennoot-aanlyn uitleenplatform",
  "application": "Leningsaansoek",
  "applicant": "Aansoeker",
  "actualName": "Regte naam",
  "yourName": "Voer asseblief die naam in",
  "term": "Leningstermyn",
  "applicationAmount": "Aangevraagde bedrag",
  "rates": "Lening rentekoers",
  "loanMethod": "Leenwyse",
  "accountB": "Rekening balans",
  "countryOf": "Nasionaliteit",
  "myloan": "My lening",
  "applyLoan": "Doen aansoek om 'n lening",
  "loaned": "Geleen",
  "interest": "Rente opgeloop",
  "esRepayment": "Geskatte terugbetaling",
  "loanHistory": "Leningsrekord",
  "applicantDate": "Aansoek datum",
  "repayment": "Terugbetaling",
  "cycle": "Terugbetalingsiklus",
  "fixedRate": "Vaste rentekoers",
  "successLoan": "Lening het geslaag",
  "Reapply": "Doen weer aansoek",
  "borrow": "Lening het misluk",
  "applicantIn": "Aansoek aan die gang",
  "repaid": "Terugbetaling",
  "overdue": "Agterstallig",
  "estirepay": "Geskatte terugbetaling",
  "loanDays": "Aantal dae geleen",
  "reAmount": "Terugbetalingsbedrag",
  "repay": "Terugbetalingsmodus",
  "entRepay": "Bevestig terugbetaling",
  "foryourmoney": "As jy in ’n tekortfonds is, nêrens kry om geld te leen nie of skaam is om geld by jou vriende te leen, kan jy ons kontak. Ons het die hele proses van professionele diens om jou twyfel te eniger tyd te beantwoord. Ons doel is om elke lening deursigtig te maak, sodat kliënte dit vinnig en met selfvertroue kan gebruik.",
  "onlineApplin": "Doen aanlyn aansoek",
  "businessloan": "Aansoek om aanvangslening",
  "selectCountry": "Kies asseblief 'n nasionaliteit",
  "selectPeriod": "Kies asseblief 'n tydperk",
  "passPortImg": "ID No./Paspoort No.",
  "uploadId": "Sertifikaatfoto/paspoort oplaai",
  "readAndAgree": "Ek het gelees en stem saam",
  "loanAgree": "Leningsooreenkoms",
  "submitApplica": "Indiening van aansoek",
  "photoExample": "Voorbeeld van foto's neem",
  "discounted": "Afslag produkte",
  "days": "dag",
  "privacyPolicy": "Privaatheidsbeleid",
  "delivery": "Aflewering en afhaal",
  "checkAgreement": "Merk asseblief die ooreenkoms!",
  "businessPhone": "Besigheidsfoon",
  "businessEmail": "Korporatiewe e-pos",
  "请选择收货地址": "Kies asseblief 'n afleweringadres",
  recommendclass:"Beveel kategorie aan",
  "滑动验证": "Sleep die skuifbalk om te verifieer",
  "最多上传9张图片": "Maksimum 9 foto's kan opgelaai word",
  "账号注销": "Rekeningafslag",
  "确定注销": "Bevestig afslag",
  "您的账号": "Jou rekening",
  "为什么要离开": "Waarom moet jy gaan",
  "职业机会": "loopbaan geleenthede",
  "您还有余额,不能注销账号": "Jy het nog 'n balans, kan nie jou rekening afslaan nie!",
  "请输入注销理由": "Voer asseblief die rede vir afslag in",
  "您确认要注销吗?": "Is jy seker jy wil jou rekening afslaan?",
  "我再考虑下": "Ek is aan die oorweeg",
  "同意注销": "Akkoord met afslag",
  "注销成功": "Afslag suksesvol",
  "cancelInfo":"waarsku! Wees asseblief versigtig om die rekening te kanselleer. As jy nie meer die rekening gebruik nie, kan jy [Agree to Cancellation] klik. Jy sal dalk nie binne 'n paar dae na kansellasie kan registreer nie.",
  "App下载(买家端)": "App aflaai (koper)",
  "App下载(卖家端)": "App aflaai (verkoper)",
  "请选择":"Kies asseblief",
  "提款地址绑定": "Uitbetalingadresbinding",
  "绑定成功": "Binding suksesvol",
  "仅能绑定一个收款地址!": "Slegs een betalingsadres kan gebind word!",
  "加值": "Waarde toevoeg",
  "提领": "Onttrekking",
  "联系商家": "Kontak verkoper",
  "银行卡": "Bankkaart",
  "平台人工发起退款": "Platform handmatige terugbetaling",
  "最多包含10位小数": "Maksimum van 10 desimale",
  "加密货币": "Kriptogeldeenheid",
  "银行卡": "Bankkaart",
  "充值币种": "Oplaai geldeenheid",
  "充值金额": "Oplaai bedrag",
  "充值金额不得小于": "Oplaai bedrag mag nie minder wees nie",
  "充值金额不得大于": "Oplaai bedrag mag nie meer wees nie",
  "请先选择币种": "Kies asseblief eers die geldeenheid",
  "开户行": "Bank",
  "请输入开户行名称": "Voer asseblief die naam van die bank in",
  "银行卡号": "Bankkaartnommer",
  "请输入银行卡号": "Voer asseblief die bankkaartnommer in",
  "点击去支付": "Klik om te betaal",
  "企业电话": "Besigheidsfoon",
  "企业证明": "Korporatiewe sertifikaat",
  '参数缺失': "Parameter ontbreek",
  '充值数量必填': "Oplaai hoeveelheid moet ingevul word",
  footTipTikTok:'CoveBuy Mall ©️2024 Kopiereg',
  "客户端下载": "Klieptaap download",
  "提现方式": "Uitbetaling",
  TikTokFoot:"CoveBuy is 'n wêreldwye kort-video sosiale platform CoveBuy en Asië se grootste groothandel handel maatskappy Alibaba, gestig in samewerking. Dit is 'n wêreldwye e-handelsplatform en het drie self-aangedrewe slim pakhuise in die wêreld, geleë in Toronto, Kanada, Los Angeles, en Chiba, Japan. Die produkte wat in die toepassing te koop is, sluit gewilde produkte van Japan, Suid-Korea, China en ander Asiatiese lande in. Op die oomblik het die totale getal 50 000 oorskry en groei steeds vinnig.",
  "betaBannerText": "Die webwerf is in openbare toetsing, plaas asseblief geen bestellings nie."
}